/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

import "./Tabs.scss";

const Tabs = ({ onChange, t }) => {
  const [option, setOption] = useState();

  useEffect(() => {
    if (option) onChange(option);
  }, [option]);

  return (
    <>
      <div className="tabs">
        <Input
          id="tab1"
          type="radio"
          name="tab-control"
          onClick={() => setOption("skill")}
          defaultChecked
        />
        <Input
          id="tab2"
          type="radio"
          name="tab-control"
          onClick={() => setOption("user")}
        />
        <ul>
          <li title="Skill">
            <label htmlFor="tab1" role="button">
              <span>{t("Skill")}</span>
            </label>
          </li>
          <li title="Agent">
            <label htmlFor="tab2" role="button">
              <span>{t("Agent")}</span>
            </label>
          </li>
        </ul>

        <div className="slider">
          <div className="indicator"></div>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(Tabs);
